import { Label, LabelEntityType } from "@api/graphql/generated/generated-types";
import React from "react";
import { Loading } from "../Loading";
import { AssignedLabelsSection } from "./components";

export interface LabelManagementProps {
  entityId: string;
  entityLabels: Label[];
  onLabelAssignmentChanged: (res: any) => void;
  onLabelCreated?: () => void | undefined;
  entityType: LabelEntityType;
}

export function LabelManagement({
  entityId,
  entityLabels,
  onLabelAssignmentChanged,
  onLabelCreated = undefined,
  entityType,
}: LabelManagementProps) {
  return (
    <Loading loading={false} className="p-4">
      <AssignedLabelsSection
        entityLabels={entityLabels}
        entityId={entityId}
        onLabelAssignmentChanged={onLabelAssignmentChanged}
        onLabelCreated={onLabelCreated}
        entityType={entityType}
      />
    </Loading>
  );
}
